var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12772_67230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00127 3.64987C8.00127 3.44564 8.00127 3.3427 8.04821 3.2587C8.09142 3.18693 8.15548 3.13005 8.23186 3.09564C8.3208 3.0594 8.41139 3.07093 8.59257 3.09234C9.40376 3.19025 10.178 3.48779 10.846 3.95833C11.514 4.42886 12.0549 5.05771 12.4202 5.78856C12.7856 6.51942 12.964 7.32947 12.9395 8.14618C12.9149 8.96289 12.6883 9.76078 12.2798 10.4684C11.8712 11.176 11.2936 11.7713 10.5986 12.2009C9.90357 12.6305 9.11286 12.8811 8.29726 12.9302C7.48165 12.9793 6.6666 12.8253 5.92509 12.4821C5.18358 12.1389 4.53875 11.6172 4.04833 10.9636C3.9388 10.8171 3.88362 10.7438 3.87127 10.6491C3.86274 10.5655 3.87998 10.4813 3.92068 10.4078C3.97009 10.3254 4.05821 10.2743 4.23527 10.1722L7.7048 8.1694C7.81268 8.10682 7.86703 8.07552 7.90574 8.03188C7.93972 7.99268 7.96598 7.94741 7.98315 7.89846C8.00127 7.84329 8.00127 7.7807 8.00127 7.65552V3.64987Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.999C11.866 14.999 15 11.865 15 7.99902C15 4.13303 11.866 0.999023 8 0.999023C4.13401 0.999023 1 4.13303 1 7.99902C1 11.865 4.13401 14.999 8 14.999Z",
    stroke: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12772_67230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClock);
export default __webpack_public_path__ + "static/media/time_clock.688fd0d2debe6e350c25be55cf00a817.svg";
export { ForwardRef as ReactComponent };